import { PreviewCart } from "../cart/preview-cart";
import { ProductVariants } from "../product/product-variants";
import { debounce } from "@app/scripts/utils/debounce";
import Swiper from 'swiper';

class ProductCardAlt extends HTMLElement {
    private swiper: Swiper | null = null;
    
    constructor() {
        super();
        this.bindEvents();
        this.initMobileSwiper();
    }

    // Initialize Swiper for mobile only
    private initMobileSwiper() {
        if (window.innerWidth <= 750) {
            const swiperContainer = this.querySelector('.product-card__swiper');
            if (swiperContainer) {
                const isInSplide = this.closest('.splide__slide') !== null;
                
                this.swiper = new Swiper(swiperContainer as HTMLElement, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    // Disable touch/swipe if inside Splide to prevent conflicts
                    allowTouchMove: !isInSplide,
                    touchRatio: isInSplide ? 0 : 1,
                    touchAngle: 45,
                    grabCursor: !isInSplide,
                });
            }
        }

        // Handle resize events to initialize/destroy swiper
        window.addEventListener('resize', debounce(() => {
            if (window.innerWidth <= 750) {
                if (!this.swiper) {
                    this.initMobileSwiper();
                }
            } else {
                if (this.swiper) {
                    this.swiper.destroy();
                    this.swiper = null;
                }
            }
        }, 300));
    }

    bindEvents() {
        const addToCartButton = this.querySelector(".product__cta-button");
        addToCartButton?.addEventListener("click", this.onAddToCartClick.bind(this));

        // Handle variant selection for alternative layout (dropdown)
        const variantSelect = this.querySelector(".variant-dropdown__selector-wrapper select") as HTMLSelectElement;
        if (variantSelect) {
            const productVariants = new ProductVariants();
            variantSelect.addEventListener("change", () => {
                const variantId = variantSelect.value;
                productVariants.onVariantSelect(variantId, this);
            });
        }
    }

    onAddToCartClick(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        
        const variantSelect = this.querySelector('.variant-dropdown__selector-wrapper select') as HTMLSelectElement;
        const itemKey = variantSelect.value;
        const quantityInput = this.querySelector('product-quantity input[type="number"]') as HTMLInputElement;
        const quantity = Number(quantityInput.value);

        const previewCart = new PreviewCart();

        previewCart.addItem(itemKey, quantity)
        .then((data: any) => {
            if (data.status && data.status >= 400) {
                previewCart.closePreviewCart();
                this.querySelectorAll(".product-form__error-message-wrapper").forEach((ele: any) => {
                    previewCart.cartErrorHandling(ele, data.description);
                })
            }
            else {
                previewCart.refreshPreviewCart(data);
            }
        })
        .catch((error) => {
            console.error("error", error)
        })
    }
}

customElements.define("product-card-alt", ProductCardAlt);
